import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
	sectionWrap: {
		height: '100%',
		width: '100%',
		margin: theme.spacing(3, 0),
	},
	heading: {
		fontWeight: theme.typography.fontWeightRegular,
	},
	link: {
		fontWeight: theme.typography.fontWeightBold,
		color: theme.palette.primary.main,
		cursor: 'pointer',
		'&:hover': {
			textDecoration: 'underline',
		},
	},
	accordion: {
		borderRadius: '0',
		border: 'none',
		boxShadow: 'none',
	},
	accordionSummary: {
		borderBottom: '1px solid rgba(0, 0, 0, .125)',
		padding: theme.spacing(0, 2),
	},
}));

export default useStyles;
